import React from "react";
import { Document, Page } from "react-pdf";
import gearIcon from "../img/gear_icon.svg";
import downloadIcon from "../img/download_icon.svg";
import deleteIcon from "../img/delete_icon.svg";

/* eslint-disable @typescript-eslint/ban-types */
interface JobCardResumeData {
  data: any;
  width: number;
}
/* eslint-enable @typescript-eslint/ban-types */

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

const JobCardResume: React.FC<JobCardResumeData> = ({ data, width }) => {
  const pdfData = React.useMemo(() => {
    return { data: atob(data) };
  }, [data]);

  return (
    <div
      className={`flex flex-col items-center border-2 border-solid border-black`}
    >
      <Document file={pdfData} options={options}>
        <Page
          pageNumber={1}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          width={width}
        />
      </Document>
    </div>
  );
};

export default JobCardResume;
